<template>
  <Cart @submit="showDelay">
    <template #item="scope">
      <SportItem :data="scope" />
    </template>
  </Cart>

  <QDialog
    v-model="show"
    persistent
  >
    <QCard
      square
      flat
      class="bg-transparent overflow-hidden"
    >
      <VueCountdown
        v-if="show"
        v-slot="{ seconds }"
        :time="delay"
      >
        <QCircularProgress
          indeterminate
          :value="seconds"
          show-value
          size="10rem"
          color="primary"
        />
      </VueCountdown>
    </QCard>
  </QDialog>
</template>
<script setup>
import { api } from '@/plugins/axios.js'
import { useCartStore } from '@/stores/cart.js'
import { useSettingStore } from '@/stores/setting.js'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { promiseTimeout } from '@vueuse/core'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import Cart from './Cart.vue'
import SportItem from './Items/SportItem.vue'
import { useAuthStore } from '@/stores/auth'
import { useDialog } from '@/composables/useDialog'
import { useConfigStore } from '@/stores/config.js'
import { useQuasar } from 'quasar'

const router = useRouter()
const cartStore = useCartStore()
const settingStore = useSettingStore()
const authStore = useAuthStore()
const configStore = useConfigStore()
const $q = useQuasar()
const { open } = useDialog()

const show = ref(false)
const delay = computed(() => Number(settingStore.liveBetDelay * 1000))

async function showDelay () {
  open({ title: '배팅을 진행 하시겠습니까?' }).onOk(async () => {
    if (delay.value > 0) {
      show.value = true
      await promiseTimeout(delay.value)
      show.value = false
      submit()
    } else {
      submit()
    }
  })
}

async function submit () {
  cartStore.submitting = true

  const bet_items = cartStore.items.map(item => ({
    game_id: item.game.id,
    live_id: item.game.live_id,
    live_market_id: item.market.id,
    argument: item.participant.argument,
    odds_name: item.odds.n,
  }))

  await api.post('live-bets', {
    bet_items,
    amount: cartStore.amount,
  }).then(() => {
    router.push({ name: 'bets', params: { category: 'live' } })
  }).finally(() => {
    cartStore.submitting = false
  })
  await authStore.fetch()
  if ($q.screen.lt.md) {
    configStore.rightDrawerOpen = false
  }
}
</script>
